import InputMail from '@/components/InputMail'
import ButtonSubmit from '@/components/ButtonSubmit'
import validateEmail from '../../pure/validateEmail'
import connect from '@/connect'

export default
{
    components:
    {
        InputMail,
        ButtonSubmit
    },

    data()
    {
        return {
            email: '',
            error: '',
            isSubmitted: false
        }
    },

    methods:
    {
        updateMail(mail)
        {
            this.email = mail
            this.error = ''
        },

        submit()
        {
            const isValid = validateEmail(this.email)
            if (!isValid)
            {
                this.error = 'Please use a valid email'
            }
            else
            {
                connect.requestToken([this.email])
                    .then(data =>
                    {
                        if (data.success)
                        {
                            this.error = ''
                            this.isSubmitted = true
                            return data
                        }
                        else
                        {
                            throw data.error
                        }
                    })
                    .catch(error =>
                    {
                        this.error = error
                    })
            }
        }
    }
}
